import gsap, { Power2 } from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { ScrollItem__BlockDefault } from './ScrollItem__BlockDefault';
import { Ease } from '../_app/cuchillo/utils/Ease';
import { Metrics } from '../_app/cuchillo/core/Metrics';

export class ScrollItem__BlockLanding extends ScrollItem__BlockDefault {
    // figure;
    // img;
    // button;
    // title;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
    }

    setAnimations() {
        super.setAnimations();

        this.figure = GetBy.selector('figure', this.item)[0];
        if (GetBy.selector('video', this.figure)[0]) {
            this.img = GetBy.selector('video', this.figure)[0];
        } else this.img = GetBy.selector('img', this.figure)[0];

        gsap.set(this.figure, { opacity: 0 });
        gsap.set(this.img, { scaleX: 1.3, scaleY: 1.3 });

        this.button = GetBy.class('button', this.item)[0];
        gsap.set(this.button, { opacity: 0 });

        const title = GetBy.selector('h1 p', this.item);
        new SplitText(title, {
            type: 'words',
            wordsClass: 'line-parent'
        });
        this.title = new SplitText(title, {
            type: 'words'
        }).words;
        gsap.set(this.title, { y: '100%' });
    }

    showFunction() {
        gsap.set(this.figure, { opacity: 0 });
        gsap.set(this.img, { scaleX: 1.3, scaleY: 1.3 });

        let delay = 0;
        gsap.to(this.img, {
            scaleX: 1,
            scaleY: 1,
            duration: 3.5,
            delay,
            ease: Ease.EASE_CUCHILLO_OUT
        });

        delay += .5;
        gsap.to(this.figure, {
            opacity: 1,
            duration: 2.5,
            delay,
            ease: Ease.EASE_CUCHILLO_OUT
        });

        for (let i = 0; i < this.title.length; i++) {
            const title = this.title[i];
            gsap.to(title, {
                y: 0,
                delay: delay + i * .15,
                duration: 1.6,
                ease: Ease.EASE_CUCHILLO_IN_OUT
            });
        }

        delay += 1.5;
        gsap.to(this.button, {
            opacity: 1,
            duration: 1,
            delay,
            ease: Power2.easeOut
        });
    }

    hideFunction() {
        super.hideFunction();
    }

    moveFunction() {
        super.moveFunction();

        const y = Maths.clamp(Maths.map(this.progress, 0.5, 1, 0, 45), 0, 100);
        const scale = Math.max(Maths.map(this.progress, 0.5, 1, 1, 1.4), 1);
        const opacity = Maths.clamp(Maths.map(this.progress, 0.5, 1, 1, 0), 0, 1);

        gsap.set(this.img, { y: `${y}%`, opacity, scale });
    }
}

Scroll._registerClass('BlockLanding', ScrollItem__BlockLanding);
